import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Button, Divider } from 'antd';
import {
  FileSearchOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import {
  CustomButton,
  CustomModal,
  CustomTable,
  CustomTabs,
  CustomText,
  FormInput,
} from '../../../../components';
import ModalAddItemRolActivo from '../components/ByRoles/ModalAddItemRolActivo';
import { Asset as assetRol } from '../components/ByRoles/ModalAddItemRolActivo';
import AdditionalAssets from '../../../Transfers/components/components/AdditionalAssets';
import { Item, TransfersRequest } from '../../../Transfers/types/transfers-response';
import { DownloadFileReqAPI } from '../../../../share/api/downloadFileService';

interface InventoryDetailViewProps {
  detailData?: TransfersRequest;
  setFooterLeft: (footer: React.ReactNode) => void;
  onDocuments: (id: string[]) => void;
  entryStates?: any;
  formikSolicitud?: any;
  onViewDetail: (id: string) => void;
  dataItems?: Item[];
  isLoadingItems?: boolean;
}

const InventoryDetailView: React.FC<InventoryDetailViewProps> = ({
  detailData,
  setFooterLeft,
  onDocuments,
  formikSolicitud,
  dataItems,
  isLoadingItems,
}) => {
  const [isRoleTechnician, setIsRoleTechnician] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedAssetRol, setSelectedAssetRol] = useState<assetRol | null>(
    null
  );
  const [filteredData, setFilteredData] = useState(dataItems);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [item, setItem] = React.useState<any>([]);

  React.useEffect(() => {
    if (!dataItems) {
      setFilteredData([]);
      return;
    }

    setFilteredData(dataItems);
  }, [dataItems]);

  useEffect(() => {
    if (!detailData?.id) return;
  
    const footerContent = (
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        <Col>
          <Row gutter={16}>
            <Col>
              <CustomButton
                label="Generar Comprobante"
                disabled={Number(detailData?.status_id) !== 7}
                onClick={handleGeneratePDF}
                icon={<FileSearchOutlined />}
                size="middle"
                buttonType="secondary"
              />
            </Col>
            <Col>
              <CustomButton
                label="Descargar Documentos"
                disabled={!detailData?.documents || detailData.documents.length === 0}
                onClick={() => {
                  if (detailData?.id) {
                    onDocuments([detailData.id.toString()]);
                  }
                }}
                icon={<DownloadOutlined />}
                size="middle"
                buttonType="secondary"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  
    setFooterLeft(footerContent);
  
    const storedToken = localStorage.getItem('auth');
    try {
      const parsedToken = JSON.parse(storedToken || '{}');
      const role = parsedToken?.role?.toLowerCase();
      setIsRoleTechnician(role === 'tecnico');
    } catch (error) {
      console.error('Error al parsear el token:', error);
      setIsRoleTechnician(false);
    }
  
  }, [detailData?.id]);
  

  const handleGeneratePDF = async () => {
  if (!detailData?.id_petition) {
    console.error('No hay ID de concepto para generar el PDF.');
    return;
  }

  try {
    await DownloadFileReqAPI.downloadPDF(detailData.id_petition.toString());
  } catch (error) {
    console.error('Error al generar el PDF:', error);
  }
};


  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value || '';
    setSearchText(value);

    if (!value) {
      setFilteredData(dataItems || []);
      return;
    }

    const filtered = (dataItems as any[])?.filter((item) => {
      const valueLower = value;
      return (
        item.description?.includes(valueLower) ||
        item.plate_code?.includes(valueLower) ||
        item.status?.includes(valueLower) ||
        item.observations?.includes(valueLower)
      );
    });

    setFilteredData(filtered);
  };

  const historyColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Realizado por',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
    },    
    {
      title: 'Estado',
      dataIndex: 'comment',
      key: 'comment',
    },
  ];

  const documentColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    }
  ];

  return (
    <Fragment>
      <CustomModal
        title={`Ver adiciones`}
        labelCancel = {`Finalizar`}
        open={modalOpen}
        width="95vw"
        onCancel={() => setModalOpen(false)}
      >
        <AdditionalAssets
          items={item}
        />
      </CustomModal>
      {/* Información General */}
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Solicitante:" strong fontSize="small" />
            <CustomText
              text={detailData?.requester || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Dependencia:" strong fontSize="small" />
            <CustomText
              text={detailData?.dependency || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Nuevo responsable:" strong fontSize="small" />
            <CustomText
              text={detailData?.new_responsible || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
         <Col span={6}>
          <div className="mb-4">
            <CustomText text="Dependencia nuevo responsable:" strong fontSize="small" />
            <CustomText
              text={detailData?.new_dependency || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Fecha solicitud:" strong fontSize="small" />
            <CustomText
              text={detailData?.query_date || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Estado de solicitud:" strong fontSize="small" />
            <CustomText
              text={detailData?.status || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="mb-4">
            <CustomText text="Observaciones:" strong fontSize="small" />
            <CustomText
              text={detailData?.observations || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[16, 16]} justify="end"></Row>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: '20px' }}
      >
        <Col xs={24} sm={12}>
          <CustomText text="Listado de activos" strong fontSize="big" />
        </Col>

        <Col xs={24} sm={12} style={{ textAlign: 'right' }}>
          <FormInput
            placeholder="Buscar..."
            value={searchText}
            onChange={handleSearch}
            label="Buscador"
            name="search"
          />
        </Col>
      </Row>

      <Divider />

      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: <span>Items</span>,
            children: (
              <CustomTable
                loading={isLoadingItems}
                rowKey="id"
                columns={[
                  { title: 'Item', dataIndex: 'id', key: 'id' },
                  {
                    title: 'Código/placa',
                    dataIndex: 'plate_code',
                    key: 'plate_code',
                  },
                  {
                    title: 'Descripción',
                    dataIndex: 'asset',
                    key: 'asset',
                  }, {
                    title: 'Clase de activo',
                    dataIndex: 'class',
                    key: 'class',
                    render: (_: any, record: any) => `${record.class_code} - ${record.class}`,
                    width: 350,
                  },
                  
                  {
                    title: 'Artículo',
                    key: 'item',
                    render: (_: any, record: any) => `${record.item_code} - ${record.item}`,
                    width: 350,
                  },
                  {
                    title: 'Adiciones',
                    dataIndex: 'assets_count',
                    key: 'assets_count',
                  },
                  {
                    title: 'Estado del elemento',
                    dataIndex: 'status',
                    key: 'status',
                  },
                  {
                    title: 'Observaciones',
                    dataIndex: 'observations',
                    key: 'observations',
                    render: (text: string) => text || 'Sin registro',
                  },
                  {
                    title: 'Acciones',
                    key: 'actions',
                    render: (value) => (
                      <Button
                        disabled={!Number(value.assets_count)}
                        onClick={() => {
                          setItem([{ ...value }]);
                          setModalOpen(true);
                        }}
                      >
                        Ver adiciones
                      </Button>
                    ),
                  },
                  
                ]}
                dataSource={filteredData || []}
              />
            ),
          },
          {
            key: '2',
            label: <span>Documentos</span>,
            children: (
              <CustomTable
                dataSource={detailData?.documents?.map((doc, index) => ({
                  key: index,
                  createdAt: doc.created_at,
                  name: doc.url?.split('/').pop(),
                  link: doc.url,
                }))}
                columns={documentColumns}
                pagination={false}
              />
            ),
          },
          {
            key: '3',
            label: <span>Historial de la solicitud</span>,
            children: (
              <CustomTable
              dataSource={detailData?.history?.map((item, index) => ({
                key: index,
                date: item.date,
                comment: item.comment,
                observations: item.observations,
                user: item.user_document + '' + ' - ' + item.user,
              }))}
                columns={historyColumns}
                pagination={false}
              />
            ),
          },
        ]}
      />

      {isModalOpen && (
        <ModalAddItemRolActivo
          isModalAddItem={isModalOpen}
          setIsModalAddItem={setIsModalOpen}
          formik={formikSolicitud}
          onAddItem={() => {}}
          selectedAssetId={selectedAssetRol}
        />
      )}
    </Fragment>
  );
};

export default InventoryDetailView;
